import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
    IonButtons,
    IonHeader,
    IonMenuButton,
    IonProgressBar,
    IonTitle,
    IonToolbar,
} from '@ionic/angular';

import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { LoadingService } from '@services/loading.service';
import { AuthStatusComponent } from '../auth-status/auth-status.component';
import { HeaderCartStatusComponent } from '../header-cart-status/header-cart-status.component';

@Component({
    selector: 'app-main-header',
    templateUrl: './main-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonHeader,
        IonToolbar,
        IonMenuButton,
        IonTitle,
        IonButtons,
        IonProgressBar,
        HeaderCartStatusComponent,
        AuthStatusComponent,
        RouterLink,
        RouterLinkActive,
        CommonModule,
    ],
})
export class MainHeaderComponent implements OnInit {
    showLoading = this._loading.isLoading.asReadonly();
    isNative = false;

    constructor(private _loading: LoadingService) {}

    ngOnInit() {
        this.isNative = Capacitor.isNativePlatform();
    }
}
